// Bootstrap Constants
export const BOOTSTRAP_INIT = '[APP] BOOTSTRAP_INIT';
export const BOOTSTRAP_COMPLETE = '[BOOTSTRAP] BOOTSTRAP_COMPLETE';
import { BASE_API_URL, LANGUAGE } from 'js/constants/App';

import { setCharactersData } from 'js/store/characters/Characters.actions';
import { setLocationsData } from 'js/store/locations/Locations.actions';
import { setMakesData } from 'js/store/makes/Makes.actions';
import { setGamesData } from 'js/store/games/Games.actions';
import { setPageTemplatesData } from 'js/store/page-templates/PageTemplates.actions';
import { setVideosData } from 'js/store/videos/Videos.actions';

import { parseData } from 'js/store/app/parser/App.parser';
import * as AppActions from 'js/store/app/App.actions';

export const startBootstrap = () => async (dispatch) => {
  try {
    const urlParams = new URLSearchParams(window.location.search);
    const preview = urlParams.get('preview');
    const response = await window.fetch(`${BASE_API_URL}get_data` + (preview ? '?preview=' + preview : ''), {
      method: 'GET',
      headers: {
        'X-Language': LANGUAGE,
      },
    });
    const data = await response.json();
    if (data) {
      preview && dispatch(AppActions.setAppPreviewMode({ preview: true }));
      const parsedData = parseData(data);

      dispatch(parseUpfrontSiteData(parsedData));
      dispatch(completeBootstrap());
      dispatch(parseDeferredSiteData(parsedData));
    } else {
      console.warn(`SOMETHING WENT WRONG: Could not get the data from the API`);
    }
  } catch (error) {
    console.error(`Error fetching site data:`, error);
  }
};

export const completeBootstrap = () => {
  return (dispatch) => {
    dispatch(AppActions.startFrontend());
  };
};

const parseUpfrontSiteData = (data) => {
  return (dispatch) => {
    // set pages data
    dispatch(AppActions.setPagesData(data.pages));
  };
};

const parseDeferredSiteData = (data) => {
  return (dispatch) => {
    // set characters data
    dispatch(setCharactersData(data.characters));

    // set locations data
    dispatch(setLocationsData(data.locations));

    // set navigation data
    dispatch(
      AppActions.setAppData({
        navigation: {
          data: data.navigation,
          subpages: {
            articles: data.page_templates,
            meet_the_characters: data.characters,
            explore_porthole: data.locations,
            games: data.games,
          },
        },
        meta: data.meta,
        social: data.social,
      })
    );

    // set make data
    dispatch(setMakesData(data.makes));

    // set games data
    dispatch(setGamesData(data.games));

    // set page templates data
    dispatch(setPageTemplatesData(data.page_templates));

    // set videos data
    dispatch(setVideosData(data.videos));
  };
};
